import { FC, memo } from "react";
import {
  IHeaderLinkChild,
} from "apps/website/components/base/Button/Button.map";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";

export interface INavigationItemChildrenAnchorTag {
  child: IHeaderLinkChild;
  onClick?: () => void;
}

const classes = "relative xl:block xl:pb-4 xl:hover:opacity-50 transition-opacity duration-300 opacity-100";

const NavigationItemChildrenAnchorTag: FC<INavigationItemChildrenAnchorTag> = ({ child, onClick }) => (<>
  { onClick ? (
    <button className={classes} onClick={onClick}>
      <TextSubtitle className="text-base md:text-base uppercase" color="default" tag="div" whitespace="noWrap">{ child.name }</TextSubtitle>
    </button>
  ) : (
    <a href={child.to} className={classes}>
      <TextSubtitle className="text-base md:text-base uppercase" color="default" tag="div" whitespace="noWrap">{ child.name }</TextSubtitle>
    </a>
  ) }
</>);

export default memo(NavigationItemChildrenAnchorTag);
